document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    (function() {
      // delegated — survives re-renders
      document.addEventListener('change', (e) => {
        const input = e.target.closest('.radio__fieldset input[type="radio"]');
        if (!input) return;
        const selected = input.closest('.radio__fieldset').querySelector('.radio__legend__selected');
        if (selected) selected.textContent = input.value;
      });

      // MutationObserver on document.body so it picks up re-rendered elements
      const observer = new MutationObserver(() => {
        const atcText = document.querySelector('[data-add-to-cart-text]');
        const cartIcon = document.querySelector('.icon-atc-cart');
        if (atcText && cartIcon) {
          cartIcon.style.display = atcText.textContent.trim() === 'Add to Cart' ? '' : 'none';
        }
      });

      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    })();
  });
});